import StudyDeskImg from '../assets/images/85247abf-f310-4792-bc48-33951b16e49e.webp';
import StudyLoadImg from '../assets/images/fc094dec-a93f-4c8a-8207-4f35ad19e9eb.webp';
import { Page } from '../components/shared/page/Page';
import { APTITUDE_SUBJECT_ID, THEORY_SUBJECT_ID } from '../constants/subjects';
import { useProfile } from '../context/ProfileContext';
import { ActivityCard } from '../features/home/activity/ActivityCard';
import { ChallengeCard } from '../features/home/challenges/ChallengeCard';
import { CompetitiveQuestionnaireCard } from '../features/home/competitive-questionnaire/CompetitiveQuestionnaireCard';
import { FormativeQuestionnaireCard } from '../features/home/formative-questionnaire/FormativeQuestionnaireCard';

import styles from './HomePage.module.scss';

function HomePage() {
  const { profile } = useProfile();

  return (
    <Page title="Inicio" loading={!profile.id}>
      <CompetitiveQuestionnaireCard />
      {/* An illustration of its own per card: the two sit side by side, and the
          monthly card and the streak below them have already spent the pair of
          officers everything else on this screen uses. */}
      <div className={styles['row']}>
        <FormativeQuestionnaireCard
          subjectId={THEORY_SUBJECT_ID}
          subject="teoría"
          image={StudyDeskImg}
          testId="ui-formative-questionnaire-card-theory"
        />
        <FormativeQuestionnaireCard
          subjectId={APTITUDE_SUBJECT_ID}
          subject="psicotécnicos"
          image={StudyLoadImg}
          testId="ui-formative-questionnaire-card-aptitude"
        />
      </div>
      <ActivityCard />
      <ChallengeCard />
    </Page>
  );
}

export { HomePage };
